import Joi from '@hapi/joi'

export const cardUploadSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name"),
    operationEntityID: Joi.number().invalid(0).required().label("OperationEntity Name"),
    collectionCatagoryID: Joi.number().invalid(0).required().label("Collection Catagory"),
    collectionPointID: Joi.number().invalid(0).required().label("Collection Catagory"),
    customers: Joi.array().min(1)
}